import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { StyledEngineProvider, ThemeProvider } from "@mui/material";
import GoogleFontLoader from "./FontLoader/index";
import { useBrandingFetch } from "./useBrandingFetch";
export const BrandingProvider = ({ children }) => {
    const { fonts, theme: NEW_THEME } = useBrandingFetch();
    return (_jsx(StyledEngineProvider, Object.assign({ injectFirst: true }, { children: _jsxs(ThemeProvider, Object.assign({ theme: NEW_THEME }, { children: [fonts.length > 0 && _jsx(GoogleFontLoader, { fonts: fonts }), children] })) })));
};
